import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { Sad } from '../../img';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { url } from '../../config/url';
const Error404 = () => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: "color-primary text-center vh-100 flex justify-content-center align-items-center" }, { children: _jsxs("div", { children: [_jsx("img", { src: Sad, className: styles.sad, alt: "sad" }), _jsx("h1", { children: "404" }), _jsx("h2", { children: t('not_page') }), _jsx(NavLink, Object.assign({ to: url, className: "color-primary", style: { textDecoration: 'underline' } }, { children: t('back_main_page') }))] }) })));
};
export default Error404;
